import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { Icon20 } from 'builder/components/Icon'

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-color: ${Colors.White};
  border-radius: 16px;
  z-index: 30;
  padding: 48px;
  gap: ${Spacing.M};

  ${Media.Phone`
    padding: 32px 20px;
  `}
`

export const CloseIconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  top: 48px;
  right: 48px;

  ${Media.Phone`
    top: 5px;
    right: 5px;
  `}
`

export const CloseIcon = styled(Icon20.Close)`
  color: ${Colors.Neutral50};
  position: absolute;
  border-radius: 28px;
  width: 28px;
  height: 28px;
  padding: 4px;
  background: ${Colors.Neutral10};

  &:hover {
    background: ${Colors.Blue10};
    color: ${Colors.Blue50};
  }

  ${Media.Phone`
    width: 24px;
    height: 24px;
    padding: 2px;
    top: 20px;
    right: 20px;
  `};
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['2XS']};

  ${Media.Phone`
    gap: ${Spacing['3XS']};
  `};
`

export const Title = styled.p`
  ${Typography.S};
  font-weight: 600;
  text-align: center;
  color: ${Colors.Neutral90};
`

export const SubTitle = styled.p`
  ${Typography.Body};
  text-align: center;
  color: ${Colors.Neutral50};
`
